import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    generos: [],
    genero: [],

  },
  mutations: {

    LoadProductos(state,buscar) {
      //let aux = [];
      state.genero = state.generos;

      let aux = state.generos.filter((x) => x["nombregenero"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.genero = state.generos;
      } else {
        state.genero = aux;
     
      }
    },



    async cargardatosgeneros(state) {

      state.generos = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.generos = response.data.data;

        });
      state.genero = state.generos
    },

    cambio(state, descripcion) {
   
      state.descripcionmodal = descripcion

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombregenero: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal

   

      var datosfalso = state.idmodal;
   
      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
          

          })

          .catch((e) => {
            console.log(e);
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
        
          })

          .catch((e) => {
            console.log(e);
          });
      }

    },


    datosmodal(state, api) {

      state.idmodal = api.idgenero,
        state.descripcionmodal = api.nombregenero

    },



    eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;
     
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
     
          //this.bandera = true;
        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}